module.exports = __webpack_public_path__ + "img/favorite_border_black_24dp.c81c29a4.svg";